import React from "react";

type CalendarHeaderProps = {
  currentDate: Date;
  onYearChange: (year: number) => void;
  onMonthChange: (month: number) => void;
};

const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  currentDate,
  onYearChange,
  onMonthChange,
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - 5 + i);

  const months = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

  return (
    <div className="flex items-center justify-between p-2 rounded-md">

      <select
        value={currentDate.getMonth()}
        onChange={(e) => onMonthChange(parseInt(e.target.value))}
        className="px-2 py-1 border rounded-md me-2"
      >
        {months.map((month, idx) => (
          <option key={idx} value={idx}>
            {month}
          </option>
        ))}
      </select>

      <select
        value={currentDate.getFullYear()}
        onChange={(e) => onYearChange(parseInt(e.target.value))}
        className="px-2 py-1 border rounded-md pe-8"
      >
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CalendarHeader;
